import request from '@/utils/request';

export function getPackageSwitchOptions(params) { return request({ url: '/admin/package_switch_strategy/options', method: 'get', params }); }
export function getPackageSwitchStrategies(params) { return request({ url: '/admin/package_switch_strategy', method: 'get', params }); }
export function savePackageSwitchStrategy(data) { return request({ url: '/admin/package_switch_strategy' + (data.id ? '/' + data.id : ''), method: data.id ? 'put' : 'post', data }); }
export function deletePackageSwitchStrategy(id) { return request({ url: '/admin/package_switch_strategy/' + id, method: 'delete' }); }
